import {
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class RemarketReleaseService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static search(
    params: {
      /** All or part of the remarketed or source submission id */
      submissionId?: string;
      /** All or part of the source policy number or policy id */
      policy?: string;
      /** Parts of the risk address: each word has to be in the street, city, state or postal code */
      address?: string;
      /**  */
      effectiveFrom?: string;
      /**  */
      effectiveTo?: string;
      /** Unreleased (the default, with the skipped policies), ReadyToRelease, Quoting, QuoteStuck, NoQuote, NotFinished, PolicyRefused, Skipped, Released or All */
      status?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/RemarketRelease/search';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        submissionId: params['submissionId'],
        policy: params['policy'],
        address: params['address'],
        effectiveFrom: params['effectiveFrom'],
        effectiveTo: params['effectiveTo'],
        status: params['status']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static release(
    params: {
      /**  */
      body?: { submissionIds?: string[] };
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/RemarketRelease/release';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static requote(
    params: {
      /**  */
      body?: { submissionIds?: string[] };
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/RemarketRelease/requote';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params['body'];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
